import React, { Fragment } from "react";
import { Col, Row, CustomInput, UncontrolledAlert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { authenticationService } from "../_services/authentication.service";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import logo from "../assets/utils/images/logo.png";
import Loader from "react-loaders";
import swal from "sweetalert";
import { api } from "../_services/api.service";
import AppCache from "../_helpers/appCache";

class Transfer extends React.Component {
  constructor(props) {
    super(props);

    this.guid = props.match.params.guid;

    this.state = {};
  }

  componentDidMount() {
    authenticationService.logout();
    setTimeout(() => {
      api.verifyTransfer(this.guid).then((u) => {
        authenticationService.login(u.email, u.password).then((ret) => {
          this.props.history.push({
            pathname: `/fullprofilepayment/` + u.userID,
          });
        });
      });
    }, 3000);
  }

  onCheckboxChange(changeEvent) {
    this.setState({ rememberMe: !this.state.rememberMe });
  }

  toggleForgotPassword() {
    this.setState({
      forgotPasswordModeVisible: !this.state.forgotPasswordModeVisible,
    });
  }

  render() {
    const isIE = window.MSCompatibleInfo != null;

    return (
      <Fragment>
        <div className="h-100 bg-deep-blue bg-animation">
          <div className="d-flex h-100 justify-content-center align-items-center">
            <Col md="8" className="mx-auto app-login-box">
              <div
                className="mx-auto mb-3"
                style={{
                  fontWeight: "bold",
                  fontSize: "x-large",
                  textAlign: "center",
                  color: "white",
                }}
              >
                <img src={logo} />
                <br></br>
                <br></br>
                Definitive Choice
              </div>

              <div
                className="mx-auto mb-3"
                style={{
                  fontWeight: "bold",
                  fontSize: "medium",
                  fontStyle: "italic",
                  textAlign: "center",
                  color: "white",
                }}
              >
                Make Great Decisions
              </div>

              <div
                className="mx-auto mb-3"
                style={{
                  fontWeight: "bold",
                  fontSize: "x-large",
                  textAlign: "center",
                  color: "white",
                }}
              >
                Please wait while we set things up
              </div>

              <div className="text-center text-white opacity-8 mt-5">
                <Loader style={{}} type="line-scale" color="white" active />
              </div>

              <div className="text-center text-white opacity-8 mt-5">
                © 2003-2022 Definitive Business Solutions, Inc. All Rights
                Reserved.
              </div>
            </Col>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Transfer;
